import promoTypes from './reducers';

import * as promoTypeOperations from './operations';
import * as promoTypeTypes from './types';

export { promoTypeOperations, promoTypeTypes };

export default promoTypes;
